'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardDataCtrl', ['form', '$state', '$scope', 'gridConfiguration', 'Department', 'departments', 'Form', 'dialog', '$translate','Authentication',"$rootScope", "$serverData", "toast", "$http", "$timeout", require('./dashboardDataCtrl')]);
app.factory('gridConfiguration', ['$state', '$serverData', '$compile', '$translate', 'siteConfig', 'toast', require('../gridFactory')]);
app.directive('gridPhotos', [require('../directives/gridPhotosDirective')]);
app.directive('gridDocs', [require('../directives/gridDocsDirective')]);
app.directive('simpleListViz', [require('../directives/simpleListDirective')]);
app.directive('pdf', [require('../directives/pdfDirective')]);
app.directive('validate', [require('../directives/validateDirective')]);
app.directive('fieldElement', [require('../directives/fieldElementDirective')]);
app.directive('groupElement', [require('../directives/groupElementDirective')]);
app.directive('formulaValidate', [require('../directives/formulaValidateDirective')]);
app.directive('simpleListValidate', [require('../directives/simpleListValidateDirective')]);
app.directive('selectValidate', [require('../directives/selectValidateDirective')]);
app.directive('signValidate', [require('../directives/signValidateDirective')]);
app.directive('fileValidate', [require('../directives/docsValidateDirective')]);
app.directive('itemsMap', ['NgMap', '$timeout', require('../directives/mapDirective')]);
app.config(['$stateProvider', require('./dashboardDataConfig')]);


